module.exports = __webpack_public_path__ + "img/order-dist.313c4729.png";